import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Real security first, ISO 27001 second",
  header: "Real security first, ISO 27001 second",
  date: "2025-08-13",
  description:
    "Why you should focus on real, verifiable security before rushing into certifications like ISO 27001.",
  category: "security",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
